import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import { GipReportStatsAndNavigation } from '../../../../common/GipReportStatsAndNavigation';
import { GipAlternativeReportType } from '../../types';
import { GipAltReportMatchesContent } from './GipAltReportMatchesContent';

import { ReportResultProps } from '@app/core/reports/types';

export function GipAltReportResultView(p: ReportResultProps<GipAlternativeReportType>) {
  const additionalChips = [
    {
      value: 'matches',
      label: `Matches (${p.result.matches.length})`,
      icon: <PlaylistPlayIcon />,
      content: <GipAltReportMatchesContent report={{ values: p.values, result: p.result }} />,
    },
  ];

  return (
    <GipReportStatsAndNavigation
      additionalChips={additionalChips}
      defaultActiveChip="matches"
      useLongLabel
    />
  );
}
